import useOnClickOutside from '$hooks/useOnClickOutside';
import { GetSharedCandidatesRosterDataOutput } from '$store/modules/candidates';
import { useState, useRef, MouseEvent } from 'react';
import { ReactComponent as Verified } from '$icons/uncolored/verified.svg';

const SPKCandidateHiddenSkills = ({
  hiddenSkills,
  uniqueId,
}: {
  hiddenSkills: GetSharedCandidatesRosterDataOutput['candidates'][number]['CandidateSkills'];
  uniqueId: number;
}) => {
  const [showHiddenSkills, setShowHiddenSkills] = useState(false);
  const parentContainer = useRef<HTMLDivElement>(null);

  useOnClickOutside(parentContainer, () => setShowHiddenSkills(false));

  const handleShowHiddenSkills = (ev: MouseEvent<HTMLButtonElement>) => {
    ev.stopPropagation();
    setShowHiddenSkills((prev) => !prev);
  };

  return (
    <div ref={parentContainer} className="relative z-10">
      <button
        className="flex overflow-x-hidden text-xs font-semibold text-gray-500 border border-solid border-gray-200 rounded p-1"
        type="button"
        onClick={handleShowHiddenSkills}
      >
        +{hiddenSkills!.length}
      </button>
      {showHiddenSkills && (
        <div className="flex flex-col absolute text-xs right-0 bg-white rounded shadow mt-2 max-h-36 overflow-auto">
          {hiddenSkills?.map((singleSkill) => (
            <div
              key={`hiddenSkill_${singleSkill.Id}_${uniqueId}`}
              className="px-4 py-2 text-nowrap hover:bg-gray-200 flex flex-row gap-2"
            >
              <span>{singleSkill.Skill.title}</span>
              {singleSkill.IsVerified && (
                <Verified className="w-4 h-4 fill-spk-brightBlue" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SPKCandidateHiddenSkills;
